/**
 * useTheme — light/dark theme state, persisted to localStorage.
 * App.jsx applies `theme` to <html data-theme> and toggles via toggleTheme.
 */
import { useState, useCallback } from 'react';

const THEME_KEY = 'aisafeplate.theme';

function initialTheme() {
  const stored = localStorage.getItem(THEME_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  // Fall back to the OS preference on first load.
  if (window.matchMedia?.('(prefers-color-scheme: dark)').matches) return 'dark';
  return 'light';
}

export default function useTheme() {
  const [theme, setTheme] = useState(initialTheme);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => {
      const next = prev === 'light' ? 'dark' : 'light';
      localStorage.setItem(THEME_KEY, next);
      return next;
    });
  }, []);

  return { theme, toggleTheme };
}
